import React from 'react';
import { LayoutDashboard, Users, Package, Settings, LogOut, ChevronLeft, Menu } from 'lucide-react';
import '../../../styles/Sidebar.css';

const NAV_ITEMS = [
  { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { id: 'teams',     label: 'Equipos',   icon: Users },
  { id: 'inventory', label: 'Inventario', icon: Package },
  { id: 'settings',  label: 'Ajustes',   icon: Settings },
];

const isMobile = () => window.innerWidth <= 768;

const Sidebar = ({ isOpen, currentView, onToggle, onViewChange, onLogout }) => {
  const mobile = isMobile();
  const sidebarClass = mobile
    ? `sidebar ${isOpen ? 'mobile-open' : 'mobile-closed'}`
    : `sidebar ${isOpen ? 'desktop-open' : 'desktop-closed'}`;

  return (
    <>
      {mobile && (
        <button className="mobile-trigger" onClick={onToggle}>
          <Menu size={20} />
        </button>
      )}

      {mobile && isOpen && (
        <div className="sidebar-overlay open" onClick={onToggle} />
      )}

      <div className={sidebarClass}>
        <div className={`sidebar-header ${isOpen ? 'open' : 'closed'}`}>
          <div className={`logo-container ${isOpen ? 'open' : 'closed'}`}>
            <div className="logo-wrapper-side">
              <img src="/img/sidebar_logo.png" alt="logo" className="logo-img" />
              <span className="logo">SiGeFar Go</span>
            </div>
          </div>
          {!mobile && (
            <button className="toggle-btn" onClick={onToggle}>
              <ChevronLeft size={18} className={`toggle-icon ${isOpen ? 'open' : 'closed'}`} />
            </button>
          )}
        </div>

        <nav className="sidebar-nav">
          {NAV_ITEMS.map(({ id, label, icon: Icon }) => (
            <button
              key={id}
              className={`nav-item ${isOpen ? 'open' : 'closed'} ${currentView === id ? 'active' : ''}`}
              onClick={() => { onViewChange(id); if (mobile) onToggle(); }}
            >
              <span className="nav-icon"><Icon size={20} /></span>
              <span className={`nav-label ${isOpen ? 'open' : 'closed'}`}>{label}</span>
            </button>
          ))}
        </nav>

        <div className="sidebar-footer">
          <button className={`logout-btn ${isOpen ? 'open' : 'closed'}`} onClick={onLogout}>
            <LogOut size={20} />
            <span className={`nav-label ${isOpen ? 'open' : 'closed'}`}>Cerrar sesión</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
